import { type PhoneNumberConfigResponse } from '@Src/types/accountTypes';
import { type Geo } from '@Src/types/locationTypes';

const baseUrl = 'https://api.flipdish.co';

export const getPhoneNumberConfig = async (
  appId: string,
  coordinates?: Geo,
  version?: string,
): Promise<PhoneNumberConfigResponse> => {
  const headers = {
    'Content-Type': 'application/json',
    'Flipdish-App-Type': 'Web',
    'Flipdish-App-Version': version || '',
    'Flipdish-White-Label-Id': appId,
  };

  const geo = coordinates || {
    Latitude: 53.3454362,
    Longitude: -6.2616217,
  };
  const data = await fetch(
    `${baseUrl}/Account/PhoneNumberConfig?Latitude=${geo.Latitude}&Longitude=${geo.Longitude}`,
    {
      method: 'GET',
      headers,
    },
  );
  const response = await data.json();
  return response;
};

export const postRequestPhoneLoginCodeSms = async (
  appId: string,
  phoneNumber: string,
  isPhoneCall?: boolean,
  version?: string,
): Promise<number> => {
  const payload = isPhoneCall
    ? {
        Fallback: 'PhoneCall',
        PhoneNumber: phoneNumber,
      }
    : {
        DeviceName: window.navigator.userAgent,
        PhoneNumber: phoneNumber,
      };

  const headers = {
    'Content-Type': 'application/json',
    'Flipdish-App-Type': 'Web',
    'Flipdish-App-Version': version || '',
    'Flipdish-White-Label-Id': appId,
  };

  const data = await fetch(`${baseUrl}/Account/RequestPhoneLoginCodeSms`, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const response = await data.json();
  return response;
};
